import React, { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { cssMap } from '@atlaskit/css';

import { PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD as DEFAULT_UNSPLASH_QUERY_WORD } from '@atlassian/company-hub-common/media-components';

import { UnsplashPopupMenu } from '@confluence/content-topper/entry-points/UnsplashPopupMenu';

import type { AddHeaderImageButtonProps } from '../pageCoverPictureTypes';

import { getUnsplashPhotos } from './unsplashAPI';

const styles = cssMap({
	addHeaderImageButton: {
		opacity: 1,
	},
});

export const AddHeaderImageButton = ({
	userOffline,
	openModal,
	openMediaBrowser,
	isModalOpenState,
	closeModal,
	handleUnsplashUpload,
	setIsUploadingPicture,
	initialUnsplashInfoArray,
	setInitialUnsplashInfoArray,
	coverPictureState,
	floatingToolbarButtonStyle,
	contentId,
	generateAIHeaderImage,
}: AddHeaderImageButtonProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const isPageTitleComponent = true;

	const onAddHeaderImageButtonHovered = useCallback(() => {
		if (initialUnsplashInfoArray.length === 0) {
			void getUnsplashPhotos(DEFAULT_UNSPLASH_QUERY_WORD, 1, isPageTitleComponent).then(
				(results) => {
					setInitialUnsplashInfoArray(results);
				},
			);
		}
	}, [initialUnsplashInfoArray, isPageTitleComponent, setInitialUnsplashInfoArray]);

	const onAddHeaderImageButtonClicked = () => {
		openModal();
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'addHeaderImageButtonClicked',
				source: 'editorPageCoverPicture',
			},
		}).fire();
	};

	const handleFocus = useCallback(() => {
		if (!isModalOpenState) {
			void coverPictureState.setIsAddHeaderImageButtonFocused(true);
		}
	}, [isModalOpenState, coverPictureState]);

	const handleBlur = useCallback(() => {
		void coverPictureState.setIsAddHeaderImageButtonFocused(false);
	}, [coverPictureState]);

	return (
		<div
			data-testid="add-header-image-button-wrapper"
			css={styles.addHeaderImageButton}
			onFocus={handleFocus}
			onBlur={handleBlur}
		>
			<UnsplashPopupMenu
				imageSrc=""
				initialUnsplashInfoArray={initialUnsplashInfoArray as any}
				openMediaBrowser={openMediaBrowser}
				handleUnsplashUpload={handleUnsplashUpload}
				setIsUploadingPicture={setIsUploadingPicture}
				coverPictureState={coverPictureState}
				closePopup={closeModal}
				userOffline={userOffline}
				floatingToolbarButtonStyle={floatingToolbarButtonStyle}
				isModalOpenState={isModalOpenState}
				onAddHeaderImageButtonClicked={onAddHeaderImageButtonClicked}
				onAddHeaderImageButtonHovered={onAddHeaderImageButtonHovered}
				contentId={contentId}
				generateAIHeaderImage={generateAIHeaderImage}
			/>
		</div>
	);
};
